import { render } from "./ModalUpdateCodFornecedor.vue?vue&type=template&id=e8265736&ts=true"
import script from "./ModalUpdateCodFornecedor.vue?vue&type=script&lang=ts"
export * from "./ModalUpdateCodFornecedor.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/camp/Desktop/code-time/acampa-gestao-pra/vuecode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__